import { render, staticRenderFns } from "./FAtransactions.vue?vue&type=template&id=64a7e8b1&scoped=true&"
import script from "./FAtransactions.vue?vue&type=script&lang=js&"
export * from "./FAtransactions.vue?vue&type=script&lang=js&"
import style0 from "./FAtransactions.vue?vue&type=style&index=0&id=64a7e8b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7e8b1",
  null
  
)

export default component.exports